import { useState, useEffect } from 'react';
import { Search, X } from 'lucide-react';
import { META } from './data';

// Distinctive nav: NO hamburger; mobile uses full-screen overlay
// Center page tabs with underline-on-active, right has reference search
export default function Header({ page, setPage }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);

  const pages = [
    { id: 'home', label: 'Home' },
    { id: 'collection', label: 'Collection' },
    { id: 'service', label: 'Service & Restoration' },
    { id: 'journal', label: 'Journal' },
    { id: 'visit', label: 'Visit' },
  ];

  return (
    <>
      <header className={`sticky top-0 z-40 transition-colors duration-500 ${scrolled ? 'bg-[#F2EBDA]/95 backdrop-blur-md border-b border-[#0E0E0E]/8' : 'bg-[#F2EBDA] border-b border-[#0E0E0E]/8'}`}>
        <div className="max-w-[1440px] mx-auto px-8 lg:px-12 grid grid-cols-[1fr_auto_1fr] items-center h-[68px] gap-8">
          <button onClick={() => setPage('home')} className="flex items-baseline gap-2 justify-self-start" data-testid="watch-logo">
            <span className="font-serif text-xl tracking-tight text-[#0E0E0E]">{META.brand}</span>
            <span className="text-[9px] tracking-[0.4em] uppercase text-[#0E0E0E]/50 font-mono">{META.tagline}</span>
          </button>
          <nav className="hidden lg:flex items-center gap-7">
            {pages.map(p => (
              <button key={p.id} onClick={() => setPage(p.id)} data-testid={`watch-nav-${p.id}`}
                className={`relative text-[11px] tracking-[0.18em] uppercase font-mono py-1 transition-colors ${page === p.id ? 'text-[#7B2D26]' : 'text-[#0E0E0E]/65 hover:text-[#0E0E0E]'}`}>
                <span dangerouslySetInnerHTML={{ __html: p.label }} />
                {page === p.id && <span className="absolute -bottom-1 left-0 right-0 h-px bg-[#7B2D26]" />}
              </button>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-4 justify-self-end">
            <div className="flex items-center gap-2 border-b border-[#0E0E0E]/30 px-1 pb-1">
              <Search className="w-3 h-3 text-[#0E0E0E]/50" strokeWidth={1.5} />
              <input placeholder="Reference no." className="bg-transparent text-[11px] font-mono uppercase tracking-wider w-28 outline-none placeholder:text-[#0E0E0E]/35" />
            </div>
            <span className="text-[10px] font-mono tracking-[0.2em] uppercase text-[#0E0E0E]/45 border-l border-[#0E0E0E]/15 pl-4">EN / FR</span>
          </div>
          <button onClick={() => setOpen(true)} className="lg:hidden justify-self-end text-[10px] font-mono tracking-[0.25em] uppercase border border-[#0E0E0E]/30 px-3 py-1.5">Menu</button>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-50 bg-[#0E0E0E] text-[#F2EBDA] lg:hidden">
          <div className="flex items-center justify-between p-8 border-b border-[#F2EBDA]/10">
            <span className="font-serif text-xl">{META.brand}</span>
            <button onClick={() => setOpen(false)}><X className="w-5 h-5" /></button>
          </div>
          <nav className="flex flex-col p-8 gap-6">
            {pages.map((p, i) => (
              <button key={p.id} onClick={() => { setPage(p.id); setOpen(false); }} className="text-left text-3xl font-serif italic hover:text-[#A88B4F]">
                <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A88B4F] not-italic mr-3 align-middle">0{i + 1}</span>
                <span dangerouslySetInnerHTML={{ __html: p.label }} />
              </button>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
